import React, { Ref, useEffect, useImperativeHandle, useRef, useState } from 'react';

interface PayloadSendProps{
	autoSubmit?: boolean,
	submitTimeout?: number,
	url: string,
	method?: 'POST' | 'GET',
	data: {
		[x: string]: any
	},
	onSubmit?: ()=>void,
}

export interface PayloadSendElement{
	submit: ()=>void,
}

var PayloadSend = React.forwardRef((props: PayloadSendProps, ref: Ref<PayloadSendElement>)=>{
	var formRef = useRef<HTMLFormElement>(null);

	useEffect(()=>{
		if(props.autoSubmit!==false){
			if(formRef.current){
				setTimeout(()=>{
					formRef.current.submit();
					if(props.onSubmit) props.onSubmit();
				}, (props.submitTimeout || 1000));
			}
		}
	}, [formRef.current]);

	useImperativeHandle(ref, ()=>{
		return {
			submit: ()=>{
				if(formRef.current){
					formRef.current.submit();
					if(props.onSubmit) props.onSubmit();
				}
			}
		}
	})
	
	return <form ref={formRef} action={props.url} method={props.method || 'POST'} style={{ display: 'none' }}>
		{!!props.data ? (
			Object.keys(props.data).map(a=>(
				<input type='hidden' name={a} value={props.data[a]} key={`PYLD-${a}`} />
			))
		) : null}
	</form>
})
export default PayloadSend;